import React from 'react';

// a list of insurance groups that shouldn't generate a form entry (not yet implemented or other reasons)
const disabledGroupSettings = [
    //'musical-instrument'
];

// a list of insurance names that shouldn't generate a form entry (they're handled differently - as part of another insurance or otherwise)
const noFormInsuranceSettings = [
    'home-basic-cooperative-security',
    'home-medium-cooperative-security',
    'home-large-cooperative-security',
    'student-home-cooperative-security'
];

const animalInsuranceGroups = [
    'cat',
    'cat-life',
    'dog',
    'dog-life',
    'small-animal'
];

const insuranceGroupSettings = {
    'accident': {
        displayName: 'Olycksfallsf�rs�kring',
        infoComponents: [],
        availableForGroup: null,
        availableForInsurances: []
    },
    'accident-senior': {
        displayName: 'Olycksfallsf�rs�kring Senior',
        infoComponents: [],
        availableForGroup: null,
        availableForInsurances: []
    },
    'child': {
        displayName: 'Barnf�rs�kring',

        infoComponents: [],
        availableForGroup: null,
        availableForInsurances: []
    },
    'home': {
        displayName: 'Hemf�rs�kring',
        infoComponents: [],
        availableForGroup: null,
        availableForInsurances: []
    },
    'house': {
        displayName: 'Villaf�rs�kring',

        infoComponents: [],
        availableForGroup: null,
        availableForInsurances: []
    },
    'holiday-cottage': {
        displayName: 'Fritidshusf�rs�kring',

        infoComponents: [],
        availableForGroup: null,
        availableForInsurances: []
    },
    'healthcare': {
        displayName: 'Sjukv�rdsf�rs�kring',
        availableForGroup: null,
        availableForInsurances: []
    },
    'healthcare-accident-senior': {
        displayName: 'Sjukv�rd vid olycksfall Senior',
        availableForGroup: null,
        availableForInsurances: []
    },
    'health': {
        displayName: 'Sjukf�rs�kring',
        availableForGroup: null,
        availableForInsurances: []
    },
    'life': {
        displayName: 'Livf�rs�kring',
        availableForGroup: null,
        availableForInsurances: []
    },
    'musical-instrument': {
        displayName: 'Musikinstrumentf�rs�kring',

        infoComponents: [],
        availableForGroup: null,
        availableForInsurances: []
    },
    'pregnant': {
        displayName: 'Gravidf�rs�kring',
        availableForGroup: null,
        availableForInsurances: []
    },
    'student': {
        displayName: 'Studerandef�rs�kring',

        infoComponents: [],
        availableForGroup: null,
        availableForInsurances: []
    },
    'student-home': {
        displayName: 'Studentf�rs�kring Bo',

        infoComponents: [],
        availableForGroup: null,
        availableForInsurances: []
    },
    'student-leva': {
        displayName: 'Studentf�rs�kring Leva',

        infoComponents: [],
        availableForGroup: null,
        availableForInsurances: []
    },
    'travel': {
        displayName: 'Resklar (ing�r i Hemf�rs�kring Stor)',
        infoComponents: [],
        availableForGroup: null,
        availableForInsurances: []
    },
    'dog': {
        displayName: 'Hundf�rs�kring',

        infoComponents: [],
        availableForGroup: null,
        availableForInsurances: []
    },
    'dog-life': {
        displayName: 'Livf�rs�kring Hund',

        infoComponents: [],
        availableForGroup: 'dog',
        availableForInsurances: ['dog-medium', 'dog-large'] // dog-life can be purchased only if these are already purchased
    },
    'cat': {
        displayName: 'Kattf�rs�kring',

        infoComponents: [],
        availableForGroup: null,
        availableForInsurances: []
    },
    'cat-life': {
        displayName: 'Livf�rs�kring Katt',

        infoComponents: [],
        availableForGroup: 'cat',
        availableForInsurances: ['cat-medium', 'cat-large'] // cat-life can be purchased only if these are already purchased
    },
    'small-animal': {
        displayName: 'Sm�djursf�rs�kring',

        infoComponents: [],
        availableForGroup: null,
        availableForInsurances: []
    }
};

export {
    disabledGroupSettings,
    insuranceGroupSettings,
    noFormInsuranceSettings,
    animalInsuranceGroups
};
